// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"reserveEditor_pageContainer__39yNN","noticeWrapper":"reserveEditor_noticeWrapper__2IyPr","mainContent":"reserveEditor_mainContent__1VZTK"};